import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize24;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.1625 2.10403C13.0756 2.03705 12.9684 2 12.8571 2H6.35714L6.20121 2.00535C4.96465 2.09057 4 3.18214 4 4.5V18.5L4.00705 18.6943C4.05388 19.3376 4.33189 19.9313 4.78189 20.3602C5.21032 20.7685 5.76658 21 6.35714 21H8.5L8.58988 20.9919C8.82312 20.9496 9 20.7455 9 20.5C9 20.2239 8.77614 20 8.5 20H6.35714L6.21754 19.9921C5.94106 19.9609 5.68257 19.8371 5.47181 19.6363C5.17504 19.3534 5 18.9439 5 18.5V4.5L5.0063 4.3543C5.07293 3.58786 5.65981 3 6.35714 3H12V7.4L12.006 7.54414C12.0739 8.35206 12.707 9 13.5 9H17V11.5L17.0081 11.5899C17.0504 11.8231 17.2545 12 17.5 12C17.7761 12 18 11.7761 18 11.5V7.5L17.9912 7.4066C17.9738 7.31484 17.9308 7.22914 17.8664 7.15977L13.2235 2.15977L13.1625 2.10403ZM18.856 17.0778L17.1375 14.613C16.7828 14.107 16.1319 13.8849 15.5307 14.0582C14.9219 14.2336 14.4989 14.776 14.4986 15.4012L14.507 17.001L13.3616 17.0012C12.9798 17.0012 12.5852 17.1539 12.323 17.4183L12.2312 17.5226C11.9637 17.865 11.9593 18.2515 12.1179 18.7507L13.1188 21.0675C13.2942 21.6248 13.8238 22 14.418 22H17.6417C17.9591 22 18.2526 21.8925 18.4837 21.7118C18.7069 21.8921 18.9908 22 19.3 22H19.7C20.418 22 21 21.418 21 20.7V18.3C21 17.582 20.418 17 19.7 17H19.3C19.1441 17 18.9945 17.0275 18.856 17.0778ZM19.7 18H19.3C19.1343 18 19 18.1343 19 18.3V20.7C19 20.8657 19.1343 21 19.3 21H19.7C19.8657 21 20 20.8657 20 20.7V18.3C20 18.1343 19.8657 18 19.7 18ZM15.4986 15.3987C15.4987 15.229 15.6203 15.073 15.8076 15.0191C16.0024 14.9629 16.2115 15.0343 16.3178 15.1858L18 17.6V20.6751C18 20.826 17.879 20.9616 17.7146 20.9931L17.6417 21H14.418C14.2539 21 14.115 20.9016 14.055 20.7196L13.0544 18.404C13.0019 18.2356 13.0028 18.1594 13.0199 18.1374C13.0751 18.0665 13.2256 18.0012 13.3616 18.0012H15.0099C15.2871 18.0012 15.5114 17.7757 15.5099 17.4985L15.4986 15.3987ZM11.5 15C11.7761 15 12 15.2239 12 15.5C12 15.7761 11.7761 16 11.5 16H7.5C7.22386 16 7 15.7761 7 15.5C7 15.2239 7.22386 15 7.5 15H11.5ZM15 12.5C15 12.2239 14.7761 12 14.5 12H7.5C7.22386 12 7 12.2239 7 12.5C7 12.7761 7.22386 13 7.5 13H14.5C14.7761 13 15 12.7761 15 12.5ZM10.5 9C10.7761 9 11 9.22386 11 9.5C11 9.77614 10.7761 10 10.5 10H7.5C7.22386 10 7 9.77614 7 9.5C7 9.22386 7.22386 9 7.5 9H10.5ZM13 7.4V3.389L17 7.697V8H13.5L13.4216 7.99242C13.1904 7.94746 13 7.7073 13 7.4Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 24 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'judge');
export default IconComponent;
